import { Component, OnInit, Input } from '@angular/core';
import { Iaddress } from 'my-lib-sanfelici/my-lib-sanfelici';


@Component({
  selector: 'app-address-view',
  templateUrl: './address-view.component.html',
  styleUrls: ['./address-view.component.scss']
})
export class AddressViewComponent implements OnInit {
@Input() address: Iaddress;
  constructor() { }

  ngOnInit() {
  }

}
